import React from "react";
import { connect } from "react-redux";
import VendorContent from "containers/request/RequestContent/VendorContent";
import reqTypes from "dictionaries/ReqTypes";
import { batteryTabsCRR, batteryTabsCRRECO } from "helpers/RequestTabsHelper";
import {
  getChecklistInitialCRR,
  getChecklistEcoCRR,
} from "helpers/ChecklistBatteryHelper";

const RequestContentCRR = ({ request, focusLab }) => {
  const checkListInitial = getChecklistInitialCRR(request);
  const checkListECO = getChecklistEcoCRR(request);

  switch (request.type) {
    case reqTypes.initial:
      return (
        <VendorContent
          tabs={batteryTabsCRR}
          checkList={checkListInitial}
          defaultTab={focusLab ? "labInfo" : "deviceInfo"}
        />
      );
    case reqTypes.eco:
      return (
        <VendorContent
          tabs={batteryTabsCRRECO}
          checkList={checkListECO}
          defaultTab={focusLab ? "labInfo" : "deviceInfo"}
        />
      );
    default:
      return null;
  }
};

function mapStateToProps({ request }) {
  return { request };
}

export default connect(mapStateToProps)(RequestContentCRR);
